import {KeypadInfoElementsModule, BuyBonusPopUpEvents} from '@gongxigames/framework/slot';
import {GameKeypadInfoMainGameState} from 'src/keypad/info/states/GameKeypadInfoMainGameState';
import {GameKeypadInfoFreeSpinsState} from 'src/keypad/info/states/GameKeypadInfoFreeSpinsState';
import {PayType} from 'com/gongxigames/math/core/game/enums/PayType';
import {GameLogic} from 'src/server/GameLogic';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';

export class GameKeypadInfoElementsModule extends KeypadInfoElementsModule {
    protected setupStates(): void {
        this.addState(new GameKeypadInfoMainGameState(this, KeypadInfoElementsModule.BASIC_STATE));
        this.addState(new GameKeypadInfoFreeSpinsState(this, KeypadInfoElementsModule.FREESPIN_STATE));
        this.gotoState(KeypadInfoElementsModule.BASIC_STATE);
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.on(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked);
    }

    protected onBuyButtonClicked(): void {
        this._isFreeGames = false;
        this.view.refreshLeftTicker('');
        this.view.refreshRightTicker('');
    }

    public getFreeGamesWin(): number {
        const pays = (this.logic as GameLogic).getSessionForPickBonusWinningRound(Bonus.FREE_GAMES_BONUS).pays;
        let noFreeGamesWin = 0;

        pays.forEach((pay) => {
            if (pay.type !== PayType.SCATTER) {
                noFreeGamesWin += pay.win * pay.bet;
            }
        });

        return this.logic.getTotalWin() - noFreeGamesWin;
    }
}
